import './register.scss';
import React from 'react';
import { Translate, translate, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvRadioGroup, AvRadio, AvForm } from 'availity-reactstrap-validation';
import { Row, Col, Alert, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { IRootState } from 'app/shared/reducers';
import { handleRegister, handleGetTotp, reset } from './register.reducer';
import { plugin, ENP, IND, download_plugin, LINK_TERM_OF_USE, PLUGIN } from 'app/config/constants';
import RegisterBottom from './registerBottom';

export interface IRegisterTokenProps extends StateProps, DispatchProps {
  userType: string;
}

export interface IRegisterTokenState {
  redirectInfo: boolean;
  userType: string;
}

export class RegisterTokenPage extends React.Component<IRegisterTokenProps, IRegisterTokenState> {
  state: IRegisterTokenState = {
    redirectInfo: false,
    userType: ''
  };

  componentDidMount() {
    // window['checkPlugin']();
    this.props.handleGetTotp();
  }

  registerUSBToken = (event, values) => {
    const totp = this.props.totp;
    if (totp) {
      Storage.session.set('totp', totp.message);
      Storage.session.set('userType', this.props.userType);
      Storage.session.set('type', 'Token');
      window['exc_sign_msg'](totp.message);
    }

    //this.setState({ userType: values.userTypeToken });
  };

  renderRedirect = () => {
    if (this.state.redirectInfo) {
      return (
        <Redirect
          push
          to={{
            pathname: '/info/register',
            state: {
              totp: this.props.totp,
              userType: this.props.userType,
              type: 'token'
            }
          }}
        />
      );
    }
  };

  render() {
    return (
      <div>
        <Row className="justify-content-center">
          <Col md="12">
            <AvForm id="register-form" onValidSubmit={this.registerUSBToken}>
              {/* <AvRadioGroup id="regToken" inline name="userTypeToken" value={IND} required>
                <AvRadio customInput label="Công dân" value={IND} />
                <AvRadio customInput label="Doanh nghiệp" value={ENP} />
              </AvRadioGroup> */}

              <div className="huong-dan-dk-sim">
                {/* <div className="title">Hướng dẫn đăng ký bằng USB Token</div> */}
                <div className="steps">
                  <div className="li">
                    <p>
                      Tải về và cài đặt công cụ ký điện tử trên Windows{' '}
                      <a className="style-link" href={PLUGIN.WINDOWS_OS}>
                        tại đây
                      </a>{' '}
                      & MacOS{' '}
                      <a className="listyle-linknk" href={PLUGIN.MAC_OS}>
                        tại đây
                      </a>
                      .
                    </p>
                  </div>
                  <label style={{ marginTop: '20px' }}>
                    <Translate contentKey="register.term1" />
                    <a target="_blank">
                      <Translate contentKey="register.term2" />
                    </a>
                    <Translate contentKey="register.term3" />
                  </label>
                </div>
              </div>

              <Button className="btn-register" type="submit" block>
                <Translate contentKey="register.form.button">Register</Translate>
              </Button>
              <div style={{ marginTop: '10px' }}>
                <RegisterBottom isInsurance={false} />
              </div>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resultReg: storeState.register.resultReg,
  currentLocale: storeState.locale.currentLocale,
  totp: storeState.register.totp,
  config: storeState.applicationProfile.config
});

const mapDispatchToProps = { handleRegister, handleGetTotp, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterTokenPage);
